import React from 'react';
import NewsSectionLink from '../components/NewsSectionLink';
import '../styles/TournamentAutoSlider.css';
import '../styles/HomeSectionTitle.css';

const TournamentAutoSlider = ({ title, items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="tournament-slider-box">
      <div className="panel">
        <h2 className="home-section-title">{title}</h2>
      </div>

      <div className="tournament-slider">
        <div className="tournament-track">
          {[...items, ...items].map((item, index) => (
            <NewsSectionLink
              to={item.link}
              section={item.name}
              key={index}
              className="tournament-item"
            >
              <img src={item.image} alt={item.name} />
              <span>{item.name}</span>
            </NewsSectionLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TournamentAutoSlider;
